/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingTolerancesListItem
 */
export interface BookingTolerancesListItem {
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesListItem
     */
    comment?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingTolerancesListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof BookingTolerancesListItem
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingTolerancesListItem
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesListItem
     */
    relevance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesListItem
     */
    allowEdit?: boolean;
}

export function BookingTolerancesListItemFromJSON(json: any): BookingTolerancesListItem {
    return BookingTolerancesListItemFromJSONTyped(json, false);
}

export function BookingTolerancesListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTolerancesListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function BookingTolerancesListItemToJSON(value?: BookingTolerancesListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'description': value.description,
        'comment': value.comment,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'relevance': value.relevance,
        'allowEdit': value.allowEdit,
    };
}


